import { useState } from 'react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import LeftSidebar from '@/js/components/sidebars/LeftSidebar';
import SidebarSheetWrapper from '@/js/components/sidebars/SidebarSheetWrapper';
import RightSideBar from '@/js/components/sidebars/RightSidebar';
import DashboardWelcome from '@/js/screens/Buyer/Dashboard/DashboardWelcome';
import BuyerDashboardScreen from '@/js/screens/Buyer/Dashboard/BuyerDashboardScreen';
import RecentActivity from '@/js/components/sidebars/RecentActivity';
import ChatWidget from '@/js/components/chat/ChatWidget';

const screenEnum = {
  WELCOME: 'welcome',
  DASHBOARD: 'dashboard',
};

const BuyerDashboard = () => {
  const [screen, setScreen] = useState(screenEnum.DASHBOARD);

  const screenFunction = () => {
    switch (screen) {
      case screenEnum.WELCOME:
        return <DashboardWelcome />;

      case screenEnum.DASHBOARD:
        return <BuyerDashboardScreen />;

      default:
        break;
    }
  };

  return (
    <div className=" grid grid-cols-customCP12 min-h-[calc(100vh-70px)] bg-backgroundGray">
      {/* messages */}
      {/* <ChatWidget /> */}
      {/* Mobile Menu Button */}
      <div className="lg:hidden col-span-12 p-4">
        <Drawer>
          <DrawerTrigger asChild>
            <Menu size={28} className="cursor-pointer mt-7 ml-5" />
          </DrawerTrigger>
          <DrawerContent>
            <div className="mx-auto w-full max-w-sm">
              <DrawerHeader>
                <DrawerTitle>Menu</DrawerTitle>
              </DrawerHeader>
              <LeftSidebar role="buyer" />
              <DrawerClose asChild>
                <Button variant="outline" className="w-full">
                  Close
                </Button>
              </DrawerClose>
            </div>
          </DrawerContent>
        </Drawer>
      </div>

      {/* Desktop Sidebar */}
      {/* <div className="hidden lg:block lg:col-span-1">
        <div className="side-menu h-full pt-5">
          <SidebarSheetWrapper role="buyer" />
        </div>
      </div> */}

      {/* Main Content */}
      <div className="col-span-12 lg:col-span-9 mt-8 mb-4 ml-3 rounded-lg">
        <BuyerDashboardScreen />
      </div>

      {/* Right Sidebar - Hidden on mobile */}
      <div className="hidden lg:block lg:col-span-3 mt-8 mb-4 mr-8 rounded-lg bg-white  h-[1000px]">
        <div className="side-menu w-full">
          <RecentActivity />
        </div>
      </div>
    </div>
  );
};

export default BuyerDashboard;
